// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"311":"f2ec8d82","726":"f7eda472","787":"f5d63d69"}[chunkId] + ".chunk.js";
};